import { useNavigate } from "react-router-dom";
import { Reveal } from "@/components/site/Reveal";

export default function Footer() {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="bg-ink text-stone pt-28 pb-10 px-6 md:px-12 flex flex-col gap-20 overflow-hidden">
      <Reveal>
        <h2 className="font-serif text-[16vw] md:text-[13vw] leading-[0.85] tracking-tighter">
          Let&apos;s talk<span className="text-derma">.</span>
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-12 border-t border-stone/15 pt-12">
        <div className="flex flex-col gap-3">
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-stone/40">Brands</span>
          <button onClick={() => navigate("/shop?brand=onekind")} className="text-left font-sans text-sm hover:text-pharma-soft transition-colors" data-testid="footer-onekind">OneKind — Pharma & Wellness</button>
          <button onClick={() => navigate("/shop?brand=oneskin")} className="text-left font-sans text-sm hover:text-derma-soft transition-colors" data-testid="footer-oneskin">One Skin — Skincare</button>
          <a href="https://inoneskin.com" target="_blank" rel="noopener noreferrer" className="font-sans text-sm hover:text-derma-soft transition-colors" data-testid="footer-inoneskin">inoneskin.com ↗</a>
        </div>

        <div className="flex flex-col gap-3">
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-stone/40">Explore</span>
          <button onClick={() => navigate("/shop")} className="text-left font-sans text-sm hover:text-stone/70 transition-colors">All Products</button>
          <a href="#manifesto" className="font-sans text-sm hover:text-stone/70 transition-colors">Manifesto</a>
          <a href="#connect" className="font-sans text-sm hover:text-stone/70 transition-colors">For Doctors</a>
        </div>

        <div className="flex flex-col gap-3">
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-stone/40">Contact</span>
          <a
            href="https://www.google.com/maps/search/?api=1&query=J-3B%2C+Udyog+Nagar%2C+Near+Udyog+Nagar+Metro+Station%2C+Delhi%2C+110041%2C+India"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-address"
            className="font-sans text-sm hover:text-stone/70 transition-colors leading-relaxed"
          >
            J-3B, Udyog Nagar, Near Udyog Nagar Metro Station, Delhi, 110041, India ↗
          </a>
        </div>

        <div className="flex flex-col gap-3">
          <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-stone/40">OneKind Healthcare</span>
          <p className="font-sans text-sm text-stone/60 leading-relaxed">
            Precision pharmaceuticals and dermatological-grade skincare, engineered for the clinicians who trust the science.
          </p>
        </div>
      </div>

      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 border-t border-stone/15 pt-8">
        <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-stone/40">© {year} OneKind Healthcare</span>
        <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-stone/40">Clinical Efficacy · Pure Formulations</span>
      </div>
    </footer>
  );
}
